module.exports = __webpack_public_path__ + "static/media/thumbshot1.1f29c186.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoImgs/thumbshot1.jpg
// module id = 119
// module chunks = 1